import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import type { ReviewApprovalItem } from "../../../../shared/types";
import { api } from "../../lib/api";
import { buildBrandScopedPath } from "../../lib/brand-navigation";
import { BlogRevisionFeedback } from "./BlogRevisionFeedback";

/** Keep drafting feedback reachable after Request changes removes a Review card. */
export function CampaignBlogRevision({ campaignId, briefId, brandId }: { campaignId: string; briefId: string; brandId: string }) {
  const status = useQuery({
    queryKey: ["blog-revision", brandId, campaignId, briefId],
    queryFn: () => api.get<{ data: ReviewApprovalItem }>(`/api/campaigns/${campaignId}/briefs/${briefId}/blog-revision`),
    refetchInterval: (query) => query.state.data?.data.blog_revision_run?.status === "running" ? 2000 : false,
  });
  if (status.isPending) return <p className="text-sm text-slate-600">Loading revision status…</p>;
  if (status.isError) return <p role="alert" className="text-sm text-red-700">Could not load revision status. Reopen the draft to try again.</p>;
  const brief = status.data.data;
  return <div className="flex flex-wrap gap-3 border-t border-slate-200 px-5 py-3">
    <BlogRevisionFeedback key={brief.id} brief={brief} brandId={brandId} />
    {brief.blog_revision_run?.status === "completed" && brief.state === "in_review" ?
      <Link className="text-sm underline" to={buildBrandScopedPath("/review", brandId)}>Open revised draft in Review</Link> : null}
  </div>;
}
